// Generated from caloriescience-api/questionnaire-data.json — do not edit by hand.
export const DEMO_CORE_QUESTIONNAIRE_LIST: Record<string, unknown>[] = [
  {
    "id": "696f888e02616daa6cbae966",
    "questionnaireId": "696f888e02616daa6cbae966",
    "title": "24 Hour Dietary Recall",
    "name": "24 Hour Dietary Recall",
    "description": "A detailed dietary recall documenting everything the client ate and drank in the previous 24 hours, organised by meal occasion. Captures meal timing, food descriptions, portion sizes, preparation methods, eating location, and any factors affecting intake. Used to identify eating patterns, nutrient gaps, and areas for improvement.",
    "type": "core",
    "questionsCount": 24,
    "estimatedTimeMinutes": 15,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "c2f4344869dcfc23e21679a4",
    "questionnaireId": "c2f4344869dcfc23e21679a4",
    "title": "Clinical Assessment",
    "name": "Clinical Assessment",
    "description": "An in-depth clinical assessment capturing the complete health picture including recent laboratory results (blood glucose, lipids, thyroid, vitamins), detailed family health history, gastrointestinal symptoms and digestive health, mental wellbeing indicators, stress and sleep quality, and the client's readiness and motivation to make dietary changes.",
    "type": "core",
    "questionsCount": 55,
    "estimatedTimeMinutes": 25,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbae9ac",
    "questionnaireId": "696f888e02616daa6cbae9ac",
    "title": "DM Gestational",
    "name": "DM Gestational",
    "description": "10 questions • 4-6 min | TRIGGER: Diabetes + Gestational (Female only)",
    "type": "conditional",
    "questionsCount": 10,
    "estimatedTimeMinutes": 6,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbae9b7",
    "questionnaireId": "696f888e02616daa6cbae9b7",
    "title": "DM LADA Men",
    "name": "DM LADA Men",
    "description": "12 questions • 5-7 min | Slow-onset autoimmune diabetes | TRIGGER: Diabetes + LADA + Male + Age ≥18",
    "type": "conditional",
    "questionsCount": 12,
    "estimatedTimeMinutes": 7,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbae9c4",
    "questionnaireId": "696f888e02616daa6cbae9c4",
    "title": "DM LADA Women",
    "name": "DM LADA Women",
    "description": "15 questions • 6-8 min | Slow-onset autoimmune diabetes | TRIGGER: Diabetes + LADA + Female + Age ≥18",
    "type": "conditional",
    "questionsCount": 15,
    "estimatedTimeMinutes": 8,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbae9d3",
    "questionnaireId": "696f888e02616daa6cbae9d3",
    "title": "DM T1 ChildTeen",
    "name": "DM T1 ChildTeen",
    "description": "21 questions • 7-9 min | TRIGGER: Diabetes + Type 1 + Age <18",
    "type": "conditional",
    "questionsCount": 21,
    "estimatedTimeMinutes": 9,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbae9e3",
    "questionnaireId": "696f888e02616daa6cbae9e3",
    "title": "DM T1 Men",
    "name": "DM T1 Men",
    "description": "12 questions • 5-7 min | TRIGGER: Diabetes + Type 1 + Male + Age ≥18",
    "type": "conditional",
    "questionsCount": 12,
    "estimatedTimeMinutes": 7,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbae9f0",
    "questionnaireId": "696f888e02616daa6cbae9f0",
    "title": "DM T1 Women",
    "name": "DM T1 Women",
    "description": "16 questions • 6-8 min | TRIGGER: Diabetes + Type 1 + Female + Age ≥18",
    "type": "conditional",
    "questionsCount": 16,
    "estimatedTimeMinutes": 8,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbae9ff",
    "questionnaireId": "696f888e02616daa6cbae9ff",
    "title": "DM T2 ChildTeen",
    "name": "DM T2 ChildTeen",
    "description": "13 questions • 6-8 min | TRIGGER: Diabetes + Type 2 + Age <18",
    "type": "conditional",
    "questionsCount": 13,
    "estimatedTimeMinutes": 8,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea0d",
    "questionnaireId": "696f888e02616daa6cbaea0d",
    "title": "DM T2 Men",
    "name": "DM T2 Men",
    "description": "9 questions • 4-6 min | TRIGGER: Diabetes + Type 2 + Male + Age ≥18",
    "type": "conditional",
    "questionsCount": 9,
    "estimatedTimeMinutes": 6,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea17",
    "questionnaireId": "696f888e02616daa6cbaea17",
    "title": "DM T2 Women",
    "name": "DM T2 Women",
    "description": "13 questions • 5-7 min | TRIGGER: Diabetes + Type 2 + Female + Age ≥18",
    "type": "conditional",
    "questionsCount": 13,
    "estimatedTimeMinutes": 7,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea24",
    "questionnaireId": "696f888e02616daa6cbaea24",
    "title": "IR ChildTeen",
    "name": "IR ChildTeen",
    "description": "10 questions • 4-6 min | TRIGGER: Insulin Resistance + Age <18",
    "type": "conditional",
    "questionsCount": 10,
    "estimatedTimeMinutes": 6,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea2f",
    "questionnaireId": "696f888e02616daa6cbaea2f",
    "title": "IR Men",
    "name": "IR Men",
    "description": "8 questions • 3-5 min | TRIGGER: Insulin Resistance + Male + Age ≥18",
    "type": "conditional",
    "questionsCount": 8,
    "estimatedTimeMinutes": 5,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea38",
    "questionnaireId": "696f888e02616daa6cbaea38",
    "title": "IR Women",
    "name": "IR Women",
    "description": "10 questions • 4-6 min | TRIGGER: Insulin Resistance + Female + Age ≥18",
    "type": "conditional",
    "questionsCount": 10,
    "estimatedTimeMinutes": 6,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "demo-core-intake",
    "questionnaireId": "demo-core-intake",
    "title": "New Client Health Profile",
    "name": "New Client Health Profile",
    "description": "Standard consultation form • 34 questions • 10-15 minutes",
    "type": "core",
    "questionsCount": 35,
    "estimatedTimeMinutes": 15,
    "assignedClientsCount": 2,
    "responsesCount": 8,
    "assigned": true,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea65",
    "questionnaireId": "696f888e02616daa6cbaea65",
    "title": "PCOS Adolescent",
    "name": "PCOS Adolescent",
    "description": "14 questions • 6-8 min | TRIGGER: PCOS + Female + Age <18",
    "type": "conditional",
    "questionsCount": 14,
    "estimatedTimeMinutes": 8,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea74",
    "questionnaireId": "696f888e02616daa6cbaea74",
    "title": "PCOS Women",
    "name": "PCOS Women",
    "description": "12 questions • 5-7 min | TRIGGER: PCOS + Female + Age ≥18",
    "type": "conditional",
    "questionsCount": 12,
    "estimatedTimeMinutes": 7,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea81",
    "questionnaireId": "696f888e02616daa6cbaea81",
    "title": "Pre-Consultation Screening",
    "name": "Pre-Consultation Screening",
    "description": "Pre-Consultation Screening - Identifies primary goals, red flags, allergies, and conditions requiring follow-up modules.",
    "type": "core",
    "questionsCount": 17,
    "estimatedTimeMinutes": 8,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea8e",
    "questionnaireId": "696f888e02616daa6cbaea8e",
    "title": "Thyroid Hashimotos ChildTeen",
    "name": "Thyroid Hashimotos ChildTeen",
    "description": "10 questions • 4-6 min | Autoimmune thyroiditis | TRIGGER: Thyroid + Hashimoto's + Age <18",
    "type": "conditional",
    "questionsCount": 10,
    "estimatedTimeMinutes": 6,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaea99",
    "questionnaireId": "696f888e02616daa6cbaea99",
    "title": "Thyroid Hashimotos Men",
    "name": "Thyroid Hashimotos Men",
    "description": "8 questions • 3-5 min | Autoimmune thyroiditis | TRIGGER: Thyroid + Hashimoto's + Male + Age ≥18",
    "type": "conditional",
    "questionsCount": 8,
    "estimatedTimeMinutes": 5,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "89fbb63bc93bc917b673f6ca",
    "questionnaireId": "89fbb63bc93bc917b673f6ca",
    "title": "Thyroid Hashimotos Women",
    "name": "Thyroid Hashimotos Women",
    "description": "10 questions • 4-6 min | Autoimmune thyroiditis | TRIGGER: Thyroid + Hashimoto's + Female + Age ≥18",
    "type": "conditional",
    "questionsCount": 10,
    "estimatedTimeMinutes": 6,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaeaad",
    "questionnaireId": "696f888e02616daa6cbaeaad",
    "title": "Thyroid Hyper ChildTeen",
    "name": "Thyroid Hyper ChildTeen",
    "description": "9 questions • 4-5 min | TRIGGER: Thyroid + Hyperthyroid + Age <18",
    "type": "conditional",
    "questionsCount": 9,
    "estimatedTimeMinutes": 5,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaeab7",
    "questionnaireId": "696f888e02616daa6cbaeab7",
    "title": "Thyroid Hyper Men",
    "name": "Thyroid Hyper Men",
    "description": "7 questions • 3-4 min | TRIGGER: Thyroid + Hyperthyroid + Male + Age ≥18",
    "type": "conditional",
    "questionsCount": 7,
    "estimatedTimeMinutes": 4,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaeabf",
    "questionnaireId": "696f888e02616daa6cbaeabf",
    "title": "Thyroid Hyper Women",
    "name": "Thyroid Hyper Women",
    "description": "9 questions • 4-5 min | TRIGGER: Thyroid + Hyperthyroid + Female + Age ≥18",
    "type": "conditional",
    "questionsCount": 9,
    "estimatedTimeMinutes": 5,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaeac9",
    "questionnaireId": "696f888e02616daa6cbaeac9",
    "title": "Thyroid Hypo ChildTeen",
    "name": "Thyroid Hypo ChildTeen",
    "description": "10 questions • 4-6 min | TRIGGER: Thyroid + Hypothyroid + Age <18",
    "type": "conditional",
    "questionsCount": 10,
    "estimatedTimeMinutes": 6,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaead4",
    "questionnaireId": "696f888e02616daa6cbaead4",
    "title": "Thyroid Hypo Men",
    "name": "Thyroid Hypo Men",
    "description": "8 questions • 3-5 min | TRIGGER: Thyroid + Hypothyroid + Male + Age ≥18",
    "type": "conditional",
    "questionsCount": 8,
    "estimatedTimeMinutes": 5,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  },
  {
    "id": "696f888e02616daa6cbaeadd",
    "questionnaireId": "696f888e02616daa6cbaeadd",
    "title": "Thyroid Hypo Women",
    "name": "Thyroid Hypo Women",
    "description": "10 questions • 4-6 min | TRIGGER: Thyroid + Hypothyroid + Female + Age ≥18",
    "type": "conditional",
    "questionsCount": 10,
    "estimatedTimeMinutes": 6,
    "assignedClientsCount": 0,
    "responsesCount": 0,
    "assigned": false,
    "status": "published"
  }
];
